import React, { FC, ReactElement, useState } from "react";
import Link from "next/link";
import { observer } from "mobx-react";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import Container from "ui/Container/Container";
import MobileMenuTrigger from "common/MobileMenuTrigger/MobileMenuTrigger";
import { useStore } from "store";
import { gtm } from "helpers/analytics";
import { useUrl } from "helpers/hooks";
import { cn } from "helpers/style";
import { ROUTE_ISG, ROUTE_PROMOS } from "constants/routes";
import styles from "./StickyCatalog.module.scss";

type Props = {
  onOpen: () => void;
  employeeMode?: boolean;
};
const StickyCatalog: FC<Props> = ({
  onOpen,
  employeeMode,
}: Props): ReactElement => {
  const { categories, search } = useStore();
  const [opened, setOpened] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const { getEntityLinkProps, getLinkProps } = useUrl();
  const blueLinks = useFeatureIsOn("ex_blueblocksheader");

  return (
    <>
      <button
        className={cn([styles.toggle, opened && styles.opened])}
        onClick={() => {
          search.showSuggestions && search.toggleShowSuggestions(false);
          setOpened(!opened);
          onOpen && onOpen();
        }}
      >
        <div className={styles.toggleButton}>
          <div className={cn([styles.toggleIcon, opened && styles.opened])}>
            <span />
          </div>
        </div>

        <span>Каталог</span>
      </button>

      <div className={styles.mobileMenu}>
        <MobileMenuTrigger />
      </div>

      <div
        className={cn([
          styles.toggleWrapper,
          opened && styles.opened,
          employeeMode && styles.toggleWrapperEmployee,
        ])}
      >
        <Container>
          <div
            className={cn([
              styles.toggleInner,
              activeIndex !== null && styles.selected,
              employeeMode && styles.toggleInnerEmployee,
            ])}
          >
            <Link
              {...getLinkProps(ROUTE_PROMOS, undefined, {
                withRegion: false,
                withOrigin: true,
              })}
              className={cn([
                styles.toggleHover,
                styles.toggleItem,
                styles.promo,
                employeeMode && styles.employeeMode,
                blueLinks && styles.blue,
              ])}
              onClick={gtm.clickPromoBtn}
              passHref
            >
              Акции
            </Link>

            <Link
              {...getEntityLinkProps("discounts")}
              className={cn([
                styles.toggleHover,
                styles.toggleItem,
                styles.discounts,
                employeeMode && styles.employeeMode,
                blueLinks && styles.blue,
              ])}
              onClick={gtm.clickDiscountsBtn}
              passHref
            >
              Скидки
            </Link>

            <Link
              {...getLinkProps(ROUTE_ISG)}
              className={cn([
                styles.toggleHover,
                styles.toggleItem,
                styles.isg,
                employeeMode && styles.employeeMode,
                blueLinks && styles.blue,
              ])}
              onClick={gtm.clickISGBtn}
              passHref
            >
              Уценка
            </Link>

            {categories.list.map((item, index) => (
              <Link
                key={index}
                {...getEntityLinkProps("category", item)}
                className={cn([
                  styles.toggleItem,
                  activeIndex === index && styles.active,
                ])}
                onMouseOver={() => setActiveIndex(index)}
                onMouseOut={() => setActiveIndex(null)}
                passHref
              >
                {item.name}
              </Link>
            ))}
          </div>
        </Container>
      </div>
    </>
  );
};

export default observer(StickyCatalog);
